export var ModalBackgroundHeader;
(function (ModalBackgroundHeader) {
    ModalBackgroundHeader["DARK"] = "dark";
    ModalBackgroundHeader["LIGHT"] = "light";
    ModalBackgroundHeader["TRANSPARENT"] = "transparent";
})(ModalBackgroundHeader || (ModalBackgroundHeader = {}));
export var ModalHeaderPadding;
(function (ModalHeaderPadding) {
    ModalHeaderPadding["MEDIUM"] = "medium";
    ModalHeaderPadding["LARGE"] = "large";
})(ModalHeaderPadding || (ModalHeaderPadding = {}));
//# sourceMappingURL=oh-fullscreen-modal.types.js.map
